<template>
  <div class="register-overlay" @click.self="$emit('close')">
    <div class="register-card">
      <button class="close-btn" @click="$emit('close')" :aria-label="t('close')">&#10005;</button>
      <OnboardingForm />
    </div>
  </div>
</template>

<script>
import { useI18n } from "../i18n.js"
import OnboardingForm from "./OnboardingForm.vue"

export default {
  name: "ChatRegister",

  components: { OnboardingForm },

  emits: ['close'],

  setup() {
    const { t } = useI18n()
    return { t }
  }
}
</script>

<style scoped>
.register-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.8);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 150;
  padding: 16px;
  overflow-y: auto;
}

.register-card {
  position: relative;
  width: min(760px, 100%);
  background: white;
  border-radius: 12px;
  margin: auto;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: rgba(255, 255, 255, 0.9);
  font-size: 20px;
  cursor: pointer;
  color: #666;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #000;
  background: #f0f2f5;
}
</style>
